var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 61,
    viewBox: "0 0 77 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_30_57458",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.6484,
    y: 33.2974,
    width: 8.32433,
    height: 18.7297,
    rx: 1.38739
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.6484,
    y: 33.2974,
    width: 8.32433,
    height: 18.7297,
    rx: 1.38739,
    stroke: "#00583E",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-1-inside-1_30_57458)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_30_57458",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.4414,
    y: 27.0541,
    width: 8.32433,
    height: 24.973,
    rx: 1.38739
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4414,
    y: 27.0541,
    width: 8.32433,
    height: 24.973,
    rx: 1.38739,
    stroke: "#00583E",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-2-inside-2_30_57458)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_30_57458",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.2344,
    y: 30.5226,
    width: 8.32433,
    height: 21.5045,
    rx: 1.38739
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40.2344,
    y: 30.5226,
    width: 8.32433,
    height: 21.5045,
    rx: 1.38739,
    stroke: "#00583E",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-3-inside-3_30_57458)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_30_57458",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.0264,
    y: 22.8918,
    width: 8.32433,
    height: 29.1351,
    rx: 1.38739
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0264,
    y: 22.8918,
    width: 8.32433,
    height: 29.1351,
    rx: 1.38739,
    stroke: "#00583E",
    strokeWidth: 4,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-4_30_57458)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8103,
    cy: 26.3603,
    r: 2.46847,
    stroke: "#00583E",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.6032,
    cy: 14.5676,
    r: 2.46847,
    stroke: "#00583E",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3972,
    cy: 22.8919,
    r: 2.46847,
    stroke: "#00583E",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.1892,
    cy: 11.7928,
    r: 2.46847,
    stroke: "#00583E",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8916 24.2792L30.5222 16.6486M34.6844 16.6486L41.9682 21.5045M46.4772 20.8108L54.1078 13.527",
    stroke: "#00583E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits04);
export default __webpack_public_path__ + "static/media/benefits_04.7515dc8c694bccf98f2d7a9cd673ab57.svg";
export { ForwardRef as ReactComponent };